import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { SeoMetadataService } from '@shared/services/seo-metadata.service';
import { TranslateService } from '@ngx-translate/core';
import { FAQ } from '@shared/data-structure/interfaces';
import { getDataFaqES, getDataFaqEN, getSchemaFAQ } from '@modules/faq-page/faq-data';
import { Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'astrea-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.scss']
})
export class FAQPageComponent implements OnInit, OnDestroy {

  public faqs!: FAQ[];
  public faqsSchema!: object;

  public books!: FAQ[];
  public purchases!: FAQ[];
  public payments!: FAQ[];
  public av!: FAQ[];

  private traslate$!: Subscription;

  constructor(
    private _t: TranslateService,
    private seo: SeoMetadataService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngOnInit(): void {
    // SEO
    this.setMetadata();

    this.faqsSchema = getSchemaFAQ();
    if (this.faqsSchema) {
      const script = this.renderer.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(this.faqsSchema);
      this.renderer.appendChild(this.document.head, script);
    }

    // PREPARE DATA
    this._t.currentLang == 'en-us' ? (this.faqs = getDataFaqEN()) : (this.faqs = getDataFaqES());
    this.prepareData();
    this.listenSetLanguage();
  }

  ngOnDestroy(): void {
    if (this.traslate$) this.traslate$.unsubscribe();
  }

  setMetadata(): void {
    this.seo.setMetadata({
      title: 'Preguntas Frecuentes',
      description: 'Preguntas frecuentes sobre los servicios de la Editorial Astrea.',
      relativeUrl: '/faq'
    });
  }

  listenSetLanguage(): void {
    this.traslate$ = this._t.onLangChange
      .subscribe({
        next: (lang: any) => {
          lang.lang == 'en-us' ? (this.faqs = getDataFaqEN()) : (this.faqs = getDataFaqES());
          this.prepareData();
        }
      })
  }

  prepareData(): void {
    this.books = this.faqs.filter((f: FAQ) => f.category == 'books');
    this.purchases = this.faqs.filter((f: FAQ) => f.category == 'purchases');
    this.payments = this.faqs.filter((f: FAQ) => f.category == 'payments');
    this.av = this.faqs.filter((f: FAQ) => f.category == 'av');
  }

}
